import React, { useState } from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Field,
  withFormik,
  ErrorMessage as FormError,
} from 'formik';

import { InputFormField, captureException } from '@playbookux/playbook-web-core';

import { func, oneOfType, object } from 'prop-types';
import { createCompany, fetchCompany } from '../../../core/actions';
import { createCompanyMutation } from './graphql';
import withLayout from '../../../core/components/with-layout';

import {
  Button,
  Container,
  ContainerField,
  Content,
  Divider,
  ErrorMessage,
  Form,
  Label,
  Segment,
  Text,
  Title,
} from './styles';

import schema from './schema';

const CreateWorkspace = ({ handleSubmit, status }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleFormSubmit = async (e) => {
    setFormSubmitted(true);
    await handleSubmit(e);
    setFormSubmitted(false);
  };

  return (
    <Container>

      <Segment>
        <Content>
          <Title>Create new workspace</Title>

          <Divider />

          <Text fontSize="16px">Just one more detail until you&#39;re on your way!</Text>

          <Form>
            <ContainerField>
              <Label>Workspace Name</Label>
              <Field
                name="name"
                component={InputFormField}
                placeholder="ABC Research Team"
                widthsize="330px"
              />
            </ContainerField>
            <FormError component={ErrorMessage} name="name" />
            {status && status.error && (
              <ErrorMessage>Error while creating company, please try again</ErrorMessage>
            )}
          </Form>

          <Button
            onClick={handleFormSubmit}
            type="submit"
            loading={status && status.isLoading}
            disabled={(status && status.isLoading) || formSubmitted}
          >
            Create
          </Button>
        </Content>
      </Segment>
    </Container>
  );
};

CreateWorkspace.propTypes = {
  handleSubmit: func.isRequired,
  status: oneOfType([object]).isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  createCompany,
  fetchCompany,
}, dispatch);

const mapStateToProps = ({ authentication }) => ({
  userId: authentication.profile.user_id,
});

export default compose(
  withLayout({ hideCompanyDropdown: true }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withFormik({
    validationSchema: schema,
    enableReinitialize: true,
    mapPropsToValues: () => ({
      name: '',
    }),
    handleSubmit: async (values, { props, setStatus }) => {
      try {
        setStatus({ isLoading: true });
        const result = await createCompanyMutation(props.userId, values.name);
        props.createCompany(result.createCompany.company);
        setStatus({ isLoading: false });
        props.history.push({ pathname: '/', state: null });
      } catch (error) {
        captureException('CREATE_COMPANY_MUTATION_FAILED', error);
        setStatus({ isLoading: false, error: true });
      }
    },
  }),
)(CreateWorkspace);
